// Presentation permissions mirror server-owned modules; no client-side grant.
export function fleetTabs(modules=[]) {
 const enabled=new Set(modules);
 return [...(enabled.has('orders')?['orders']:[]),...(enabled.has('daily_reports')&&!enabled.has('orders')?['reports']:[]),...(enabled.has('payroll')||enabled.has('expenses')?['payroll']:[]),'me'];
}
export function fleetAccountItems(modules=[]) {
 const enabled=new Set(modules);
 return ['profile',...(enabled.has('leave')?['leave']:[]),...(enabled.has('payroll')?['payslips']:[]),'password','delete'];
}
